import { render, staticRenderFns } from "./OtherGallery.vue?vue&type=template&id=ae8f23e8&scoped=true&"
import script from "./OtherGallery.vue?vue&type=script&lang=ts&"
export * from "./OtherGallery.vue?vue&type=script&lang=ts&"
import style0 from "./OtherGallery.vue?vue&type=style&index=0&id=ae8f23e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8f23e8",
  null
  
)

export default component.exports